window.IgLightbox = {
    instance: null,
    sources: null,

    async init(containerOrSources = document) {
        const elements = containerOrSources instanceof Element || containerOrSources === document
            ? containerOrSources.querySelectorAll('[data-fslightbox="gallery"], .lightbox')
            : containerOrSources;

        if (!elements.length) return;

        this.sources = elements;
        const config = typeof IgLightboxConfig !== "undefined" ? IgLightboxConfig : {};

        try {
            const { IgLightbox: LightboxClass } = await import('@internetgalerie/ig-lightbox/IgLightbox.js');
            this.instance = new LightboxClass({ sources: this.sources, ...config });
            this._bindEvents();
        } catch (err) {
            console.error("Failed to load IgLightbox:", err);
        }
    },

    reload(containerOrSources = document) {
        this.instance?.destroy();
        this.instance = null;
        this.init(containerOrSources);
    },

    _bindEvents() {
        document.addEventListener('click', (e) => {
            const anchor = e.target.closest('a.lightbox, a[data-fslightbox="gallery"]');
            if (!anchor || !this.instance) return;

            e.preventDefault();
            const index = Array.from(this.sources).indexOf(anchor);
            if (index !== -1) {
                this.instance._handleImageClick(e, index, anchor);
            }
        });
    }
};

// Auto-init on page load
window.IgLightbox.init();